export default __webpack_public_path__ + "static/media/help.37d3c616.svg";